import * as React from 'react'; // tslint:disable-line
import { DefaultImage, ImageComponent } from '@shapeable/ui';

// -------- Types -------->

export const Image: ImageComponent = (props) => {
  const { image } = props;

  if (!image) {
    return null;
  }

  return <DefaultImage {...props} />;
};